module.exports = __webpack_public_path__ + "img/H4.ac474715.png";